import React from 'react';
import { connect } from 'react-redux';
import { createCookie } from '../../common/Cookie';
import { storageAvailable } from '../../common/storageAvailable';
import { tiggerEventOnCategoryChanged } from './utils';
import properties from '../../../modules/ajio-util/properties';
class CategoryButtonMobile extends React.Component {
  TypeClassification(event) {
    const type = event.target.value;
    const path = event.target.name;
    var date;
    if (storageAvailable('localStorage')) {
      localStorage.setItem('categoryClicked', event.target.name);
      createCookie('categoryClicked', path, 730);
      if (type == 'core') {
        localStorage.setItem('categoryType', 'core');
        localStorage.setItem('categoryPath', path);
        date = new Date();
        localStorage.setItem('coreSelectedOn', date);
        createCookie('categoryType', 'core', 730);
        createCookie('categoryPath', path, 730);
        createCookie('coreSelectedOn', date, 730);
      } else {
        localStorage.setItem('categoryType', 'noncore');
      }
    }
  }

  triggerEvent = (categories = {}) => () => {
    tiggerEventOnCategoryChanged(categories);
    window.location.href = categories.nativeCategoryPageId;
  };

  render() {
    const { buttonsCatNav = {} } = this.props;
    const imageBaseUrl = properties.getProperty("imageBaseUrl");
    const { category } = this.props;
    const { fromPage } = this.props;
    var eventAction = '';
    var classForCatNav = '';
    if (this.props.fromPage == 'home') {
      eventAction = 'CategoryNav';
      classForCatNav = 'bg-cat-nav-home';
    } else if (this.props.fromPage == 'mobHeader') {
      eventAction = 'buttonTap';
      classForCatNav = 'bg-cat-nav-mobhead';
    }
    if (this.props.category) {
      var typeSelected = localStorage.getItem('categoryClicked');
    }
    const subTextObj =
      buttonsCatNav.filter((data = {}) => {
        if (data.content) {
          return true;
        }
        return false;
      })[0] || {};
    const { content: subtext = '' } = subTextObj;

    const buttonCategories =
      buttonsCatNav.filter(data => {
        const { nativeCategoryNavigationListDetails } = data;
        if (nativeCategoryNavigationListDetails) {
          return true;
        }
        return false;
      })[0] || {};
    const { nativeCategoryNavigationListDetails = [] } = buttonCategories;
    const buttonCatNavDetails = nativeCategoryNavigationListDetails
      ? nativeCategoryNavigationListDetails.map((categories, index) => {
          return (
            <a
              key={`btn-cat-nav-mob-${index}`}
              className="no-outline-mob"
              data-ga-event-category="Page Interaction"
              data-ga-event-action={eventAction}
              data-ga-event-label={categories.nativeCategoryName}
              onClick={this.triggerEvent(categories)}
            >
              {typeSelected === categories.nativeCategoryPageId.toLowerCase() ? (
                <button
                  className="btn-cat-nav-mob btn-selected-mob no-outline-mob"
                  name={categories.nativeCategoryPageId}
                  value={categories.nativeCategoryType}
                >
                  {categories.nativeCategoryName}
                  {categories.nativeCategoryLabel ? (
                    <span className="label-mob">
                      {categories.nativeCategoryLabel.toUpperCase()}
                    </span>
                  ) : null}
                </button>
              ) : (
                // <a href={categories.nativeCategoryPageId} key={`btn-cat-nav-mob-${index}`} className="no-outline-mob">
                <button
                  className="btn-cat-nav-mob no-outline-mob"
                  name={categories.nativeCategoryPageId}
                  value={categories.nativeCategoryType}
                >
                  {categories.nativeCategoryName}
                  {categories.nativeCategoryLabel ? (
                    <span className="label-mob">
                      {categories.nativeCategoryLabel.toUpperCase()}
                    </span>
                  ) : null}
                </button>
              )}
            </a>
          );
        })
      : null;
    return (
      <div className={classForCatNav}  style={{backgroundImage: `url(${`${imageBaseUrl}/static/img/catnav_mob_bg.png`})`, backgroundRepeat: 'repeat-x' }}>
        <div className="logo-div-mob">
          <span className="ic-ajio-logo logo-cat-nav" />
        </div>
        <div className="text-cat-nav">{subtext}</div>
        <div onClick={this.TypeClassification} className="selected-category">
          {buttonCatNavDetails}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { HomeReducer = {} } = state;
  const { pageDetails = [] } = HomeReducer;
  return {
    buttonsCatNav: pageDetails
  };
}

export default CategoryButtonMobile = connect(mapStateToProps)(CategoryButtonMobile);
